import { ConversionProjectionDto, CustomerConversionSettingDto } from 'common/api/autogenerated/trading-gateway';

export const exchangeInitialState: {
  exchangeSettings: CustomerConversionSettingDto;
  loading: boolean;
  error?: boolean;
  history: ConversionProjectionDto[];
} = {
  history: [],
  exchangeSettings: {},
  loading: false,
  error: undefined,
};
